export const modalTypes = {
    TOGGLE_MODAL: 'TOGGLE_MODAL',
    CLOSE_MODAL: 'CLOSE_MODAL'
};


// WEBPACK FOOTER //
// ./~/pluton-core/lib/actions/types/modal.types.js